// extracted by mini-css-extract-plugin
module.exports = {"dialogQuestion":"Snapshots_dialogQuestion__yBJF0","description":"Snapshots_description__3pbJE"};